import { render, staticRenderFns } from "./scrotalDueList.vue?vue&type=template&id=680abdb2&scoped=true&"
import script from "./scrotalDueList.vue?vue&type=script&lang=js&"
export * from "./scrotalDueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680abdb2",
  null
  
)

export default component.exports